import * as React from 'react';
import * as ReactDOM from 'react-dom';
import './css/base.css';
import './css/spinner.css';
import './modules/i18n';
import 'moment/locale/ko';
import App from './App';
import 'moment-timezone';
import ReactGA from 'react-ga';
import { setPlayerId as updatePlayerId } from 'src/modules/api';

(window as any).member = {
  setPlayerId(playerId: string) {
    localStorage.setItem('oneSignalPlayerId', playerId);
    try {
      if (playerId !== null) {
        updatePlayerId(playerId);
      }
    }
    catch {
      // 
    }
  }
}

ReactGA.initialize('UA-158960430-1');

ReactDOM.render(
    <App />,
  document.getElementById('root') as HTMLElement
);



// WEBPACK FOOTER //
// ./src/index.tsx